<script setup>
import { Link } from '@inertiajs/vue3';
</script>

<script>
export default {
    props: {
        folderName: {
            type: String,
            required: true
        },
        promoLink: {
            type: String,
            default: '#'
        },
    },
    data() {
        return {
            isOpen: false,
            /*
            imagesLoaded: false,
            resolvedImages: {
                webp500: '', webp800: '', webp1200: '',
                jpg500: '', jpg800: '', jpg1200: ''
            }
            */
        };
    },
    computed: {
        promoPath() {
            // return `../../images/promotions/${this.folderName}`;
            return `/storage/promotions/${this.folderName}`;
        },
        cookieName() {
            return `promo_shown_${this.folderName}`;
        }
    },
    methods: {
        /*
        async resolvePromoImages() {

            const allImages = import.meta.glob('../../images/promotions/**');

            const basePrefix = `../../images/promotions/${this.folderName}`;

            try {
                // Megkeressük a Vite által lefordított (hashed) URL-eket
                const webp500Mod = await allImages[`${basePrefix}/promo-500.webp`]();
                const webp800Mod = await allImages[`${basePrefix}/promo-800.webp`]();
                const webp1200Mod = await allImages[`${basePrefix}/promo-1200.webp`]();

                const jpg500Mod = await allImages[`${basePrefix}/promo-500.jpg`]();
                const jpg800Mod = await allImages[`${basePrefix}/promo-800.jpg`]();
                const jpg1200Mod = await allImages[`${basePrefix}/promo-1200.jpg`]();

                this.resolvedImages = {
                    webp500: webp500Mod.default,
                    webp800: webp800Mod.default,
                    webp1200: webp1200Mod.default,
                    jpg500: jpg500Mod.default,
                    jpg800: jpg800Mod.default,
                    jpg1200: jpg1200Mod.default,
                };

                this.imagesLoaded = true;
            } catch (error) {
                console.error("Nem sikerült betölteni a promóciós képeket a resources mappából. Ellenőrizd a fájlneveket!", error);
            }
        },
        */
        closeModal() {
            this.isOpen = false;
            // Elmentjük a sütit 1 napra ("1d" vagy 60 * 60 * 24 másodperc a plugin verziójától függően)
            this.$cookies.set(this.cookieName, 'true', '1d');
        }
    },
    async mounted() {
        // await this.resolvePromoImages();

        if (!this.$cookies.get(this.cookieName)) {
            setTimeout(() => {
                this.isOpen = true;
            }, 1000);
        }
    }
}
</script>

<style scoped>
.btn-close {
    opacity: 0.8;
    transition: opacity 0.2s ease;
}

.btn-close:hover {
    opacity: 1;
}

.z-3 {
    z-index: 3;
}

.bs-modal-enter-active,
.bs-modal-leave-active {
    transition: opacity 0.3s ease;
}

.bs-modal-enter-from,
.bs-modal-leave-to {
    opacity: 0;
}

.bs-modal-enter-active .modal-anim-target,
.bs-modal-leave-active .modal-anim-target {
    transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    /* Elegáns, picit ruganyos ív */
}

.bs-modal-enter-from .modal-anim-target {
    transform: scale(0.95) translateY(-20px);
}

.bs-modal-leave-to .modal-anim-target {
    transform: scale(0.95) translateY(10px);
}
</style>

<template>

    <Transition name="bs-modal" @after-leave="isOpen = false">
        <div v-if="isOpen" class="modal fade show d-block" :style="{ backgroundColor: isOpen ? 'rgba(0, 0, 0, 0.8)' : 'transparent' }" ref="promoModal" tabindex="-1" aria-labelledby="promoModalTitle" data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered modal-lg modal-anim-target">
                <div class="modal-content rounded shadow border-0">
                    <button type="button" class="btn-close position-absolute top-0 end-0 m-3 z-3 bg-white p-2 rounded-circle shadow-sm" @click="closeModal" aria-label="Bezárás"></button>
                    <div class="modal-body p-0 ratio ratio-16x9 bg-dark">
                        <Link :href="promoLink ? promoLink : '#'" class="d-block w-100 h-100" @click="closeModal">
                            <picture>
                                <source type="image/webp" :srcset="`${promoPath}/promo-500.webp 500w, ${promoPath}/promo-800.webp 800w, ${promoPath}/promo-1200.webp 1200w`" sizes="(max-width: 576px) 100vw, (max-width: 992px) 800px, 1200px">
                                <source type="image/jpeg" :srcset="`${promoPath}/promo-500.jpg 500w, ${promoPath}/promo-800.jpg 800w, ${promoPath}/promo-1200.jpg 1200w`" sizes="(max-width: 576px) 100vw, (max-width: 992px) 800px, 1200px">
                                <img :src="`${promoPath}/promo-800.jpg`" alt="Promóció" class="w-100 h-100 object-cover d-block">
                            </picture>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </Transition>

</template>
